import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Risorsa} from '../../../_models/Risorsa';
import {Movimento} from '../../../_models/Movimento';
import {Contenitore} from '../../../_models/Contenitore';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {MovimentiService} from '../../../_services/movimenti.service';
import {SaveMessage} from '../../../_helpers/save-message';
import {Spedizione} from '../../../_models/Spedizione';

@Component({
  selector: 'app-documento-magazzino-add-prelievo',
  templateUrl: './documento-magazzino-add-prelievo.component.html',
  styleUrls: ['./documento-magazzino-add-prelievo.component.scss'],
})
export class DocumentoMagazzinoAddPrelievoComponent {
  spedizione: Spedizione;
  codArt = '';
  magazzino: Risorsa;
  movimenti: Movimento[] = [];
  loading = false;

  constructor(
    private saveMessage: SaveMessage,
    private organizzazioneService: OrganizzazioniService,
    private movimentiService: MovimentiService,
    private modalCtrl: ModalController) { }


  selectContenitore = (contenitore: Contenitore) => {
    if (this.movimenti && this.movimenti.length > 0) {
      const valid = this.movimenti
        .filter((_mov: Movimento) => _mov.codBox === contenitore.codice);
      if (valid && valid.length) {
        return false;
      }
    }
    const movimento: Movimento = {
      organizzazioneId: this.organizzazioneService.organizzazioneId,
      id: 0,
      dataUnixRegistrazione: Math.floor(new Date().getTime() / 1000),
      rifOdP: contenitore.rifOdP,
      idRigaMateriale: 0,
      idSpedizione: this.spedizione.idSpedizione,
      idAnagrafica: this.spedizione.idAnagrafica,
      idIndrizzoSped: this.spedizione.idIndrizzoSped,
      codArt: contenitore.codArt,
      varianteArt: contenitore.varianteArt,
      unitaMisura: contenitore.udM,
      udM2: contenitore.udM2,
      magUdM: contenitore.magUdM,
      quantita: contenitore.giacenza,
      quantitaUdM2: contenitore.giacenzaUdM2,
      coeffX1: 1,
      codLottoAlfa: contenitore.codLottoAlfa,
      codMagazzinoOut: contenitore.codMagazzino,
      codMagAreaOut: contenitore.codMagArea,
      codBox: contenitore.codice,
      contesto: 0,
      tipoMovimento: -1
    };
    this.movimenti = [...this.movimenti, movimento];
  };

  confirm = () => {
    const promiseArray = [];
    this.loading = true;
    this.movimenti.forEach((movimento: Movimento) => {
      promiseArray.push(this.movimentiService.createMovimentoAsync(movimento));
    });
    Promise.all(promiseArray)
      .then(() => this.modalCtrl.dismiss(true, 'confirm'))
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione del movimento."))
      .finally(() => this.loading = false);
  };
  cancel = () => this.modalCtrl.dismiss(false, 'cancel');
}
